module.exports = __webpack_public_path__ + "img/8408-visa_102499.856bc19e.svg";